<template>
    <div class="m-2">
        <div class="content-container checkout-box radius-anchor">
            <div>
                <div class="text-center">
                    <h2 class="text-2xl font-bold mb-3">{{ $t('tables.landing.title') }}</h2>
                    <h3 class="text-lg">{{ $t('tables.landing.subtitle') }}</h3>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'table.landing',
}
</script>
